import { api } from "@/_store/api-client";
import {
  ICreatePersonReportRequest,
  ICreatePersonReportResponse,
  IGetPersonReportRequest,
  IGetPersonReportResponseWrapper
} from "./contracts";

export const personApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createPersonReport: builder.mutation<ICreatePersonReportResponse, ICreatePersonReportRequest>({
      query: (requestBody) => ({
        url: "/api/v1/fizics/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: (result) => result?.id ? [{ type: "ReportPerson", id: result.id }] : [],
    }),
    getPersonReport: builder.query<IGetPersonReportResponseWrapper, IGetPersonReportRequest>({
      query: ({ id }) => ({
        url: `/api/v1/fizics/${id}/`,
        method: "GET",
      }),
      providesTags: (_result, _error, { id }) => id ? [{ type: "ReportPerson", id }] : [],
    }),
  }),
  overrideExisting: false,
});

export const { useCreatePersonReportMutation, useGetPersonReportQuery } = personApi;
